<template>
  <div class="content" style="width:978px;" id="content">
    <!-- <breadcrumb></breadcrumb> -->
    <router-view></router-view>
  </div>
</template>

<script>
import breadcrumb from '@/components/breadcrumb';
export default {
  components: {
    breadcrumb
  },
  data () {
    return {};
  }
}
</script>

<style lang="scss" scoped>
.content {
  // position: absolute;
  //left: 200px;
  min-height: 976px;
  box-sizing: border-box;
  margin-left: 6px;
}
</style>


// WEBPACK FOOTER //
// src/page/layout/component/main-content/content.vue